import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminatorFetchAction from './inseminatorFetch.action.json' with { type: 'json' }
import { inseminatorObject } from '../inseminatorObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'

const inseminatorFetchDefinition = defineAction({
  ...inseminatorFetchAction,

  input: inseminatorObject
    .pick({
      id: true,
    })
    .extend({ includeInactivated: z.boolean().optional() }),
  output: inseminatorObject.extend({
    citizen: citizenObject,
  }),
})

export default inseminatorFetchDefinition
